import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useRouter } from 'next/router';
import { Table, Spin } from 'antd';
import Skeleton from '@material-ui/lab/Skeleton';
import { firebaseFireStore } from '../../config/firebaseFirestore';
import {
  collection,
  deleteDoc,
  doc,
  getDocs,
  query,
  where,
  orderBy,
} from 'firebase/firestore/lite';

export default function CollectionNfts(props) {
  const userDataRedux = useSelector((state) => state.authReducer.userData);

  const router = useRouter();
  const [myCollection, setMyCollection] = useState('');
  const [loadingNfts, setloadingNfts] = useState(true);
  const [nftData, setnftData] = useState([]);

  useEffect(() => {
    if (userDataRedux?.uid) {
      getSellerCollections();
      getNfts();
    }
  }, [userDataRedux]);

  const getNfts = async () => {
    let queryArr = [];
    queryArr.push(collection(firebaseFireStore, 'musicartNfts'));
    queryArr.push(where('usersId', 'array-contains', userDataRedux.uid));
    queryArr.push(orderBy('creationDate', 'desc'));
    let dataObj = await getDocs(query(...queryArr));

    let nftArr = [];
    dataObj.docs.map(async (ele, index) => {
      nftArr.push({ ...ele.data(), id: ele.id });
    });
    setnftData([...nftArr]);
  };

  const getSellerCollections = async () => {
    const q = query(
      collection(firebaseFireStore, 'musicartCollections'),
      where('creator', '==', userDataRedux.uid),
    );

    let collectionsData = await getDocs(q);

    if (collectionsData.empty) {
      setloadingNfts(false);
      return null;
    } else {
      let arr = [];
      collectionsData.forEach((doc) => {
        arr.push(doc.data());
      });
      setloadingNfts(false);

      setMyCollection(arr);
    }
  };

  const columns = [
    {
      title: 'Collection Name ',
      key: 'name',
      dataIndex: 'displayName',
      render: (text, record) => {
        return <span>{text}</span>;
      },
    },

    {
      title: 'NFTs',
      key: 'name',
      dataIndex: 'name',
      render: (text) => (
        <span className="flex ">
          {!loadingNfts && findCollectionNfts(text)}
        </span>
      ),
    },
    {
      title: 'Action',
      dataIndex: 'name',
      key: 'name',
      render: (text, record) => (
        <button
          className={`bg-blueGray-700 active:bg-blueGray-600 uppercase text-white font-bold hover:shadow-md shadow text-xs px-4 py-2 rounded outline-none focus:outline-none sm:mr-2 mb-1 ease-linear transition-all duration-150 ${
            findCollectionNfts(text) ? 'cursor-not-allowed' : 'cursor-pointer'
          }`}
          onClick={() => deleteCollection(record.id)}
          disabled={findCollectionNfts(text)}
          style={{
            opacity: 1,

            textTransform: 'uppercase',
            cursor: findCollectionNfts(text) ? 'not-allowed' : 'pointer',
          }}
        >
          Delete
        </button>
      ),
    },
  ];

  const findCollectionNfts = (collection) => {
    let noOfNfts =
      nftData.length > 0 ? (
        nftData.filter(
          (nft) => nft?.collection?.toLowerCase() === collection.toLowerCase(),
        ).length
      ) : (
        <Spin />
      );
    return noOfNfts;
  };

  const deleteCollection = async (id) => {
    setloadingNfts(true);
    await deleteDoc(doc(firebaseFireStore, 'musicartCollections', id)).then(
      () => {
        setMyCollection(myCollection.filter((nft) => nft.id != id));
        setloadingNfts(false);
        toast.success('Collection deleted successfully', {
          position: 'bottom-left',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          zIndex: 2147483641,
        });
      },
    );
  };

  return (
    <div>
      <div className="nft-card-con">
        {!loadingNfts && myCollection.length > 0 && (
          <div className="w-full">
            <Table
              pagination={false}
              columns={columns}
              dataSource={myCollection}
            />
          </div>
        )}

        {loadingNfts && (
          <div
            className="flex 	w-full my-6 mx-6"
            style={{ flexDirection: 'column' }}
          >
            <Skeleton animation="wave" height={20} width="60%" />
            <Skeleton animation="wave" height={20} width="60%" />
            <Skeleton animation="wave" height={20} width="60%" />
          </div>
        )}

        {!loadingNfts && myCollection.length === 0 && (
          <div className="text-center w-full text-blueGray-500">
            <p className="text-center">0 Collections found</p>
          </div>
        )}
      </div>
    </div>
  );
}
